import { makeStyles } from '@mui/styles';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import Search from 'apollo-react/icons/Search';
import AiSparkles from 'apollo-react-icons/AiSparkles';
import AlignLeft from 'apollo-react-icons/AlignLeft';
import ArrowDown from 'apollo-react-icons/ArrowDown';
import Calendar from 'apollo-react-icons/Calendar';
import Card from 'apollo-react-icons/Card';
import ChartBar from 'apollo-react-icons/ChartBar';
import CheckboxChecked from 'apollo-react-icons/CheckboxChecked';
import CheckboxError from 'apollo-react-icons/CheckboxError';
import ClipboardPencil from 'apollo-react-icons/ClipboardPencil';
import ClipboardSearch from 'apollo-react-icons/ClipboardSearch';
import Cog from 'apollo-react-icons/Cog';
import Copy from 'apollo-react-icons/Copy';
import FileDocuments from 'apollo-react-icons/FileDocuments';
import GantList from 'apollo-react-icons/GantList';
import Link from 'apollo-react-icons/Link';
import OpenNew from 'apollo-react-icons/OpenNew';
import PresentationAudience from 'apollo-react-icons/PresentationAudience';
import RadioChecked from 'apollo-react-icons/RadioChecked';
import RadioError from 'apollo-react-icons/RadioError';
import Save from 'apollo-react-icons/Save';
import Table from 'apollo-react-icons/Table';
import TextBold from 'apollo-react-icons/TextBold';
import Upload from 'apollo-react-icons/Upload';
import React, { useState } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

import { addElementToFormModel, setConfirmModalOpen } from './../../../actions/editor.actions';
import MenuItemContentWithIcon from '../../../../components/MenuItemContentWithIcon';
import { useFormSelector } from '../../../../custom-hooks';
import { getUITA } from '../../../../utils/commonUtils';
import { SS_CONTROL_TYPE } from '../../../constants/form-manager.constants';
import {
  getEntityDefinition,
  getFormInfo,
  getTranslations,
} from '../../../selectors/common.selectors';
import { getAllSubFormNames } from '../../../selectors/editor.selectors';
import { getModelById } from '../../../selectors/form-manager.selectors';
import { getSubFormNamesList } from '../../../utils/editor.utils';
import { getPropTranslation } from '../../../utils/form-manager.utils';

const OPTIONS_FOR_NUMBERS = [
  {
    icon: <TextBold style={{ fontSize: 15 }} />,
    text: 'Numeric Text Box',
    value: 'ssNumericTextBox',
  },
  {
    icon: <RadioError style={{ fontSize: 15 }} />,
    text: 'Slider',
    value: 'ssSlider',
  },
];

const OPTIONS_FOR_DATE_TYPE = [
  {
    icon: <Calendar style={{ fontSize: 15 }} />,
    text: 'Date Box',
    value: 'ssDateBox',
  },
];

const OPTIONS_FOR_STRING = [
  {
    icon: <TextBold style={{ fontSize: 15 }} />,
    text: 'Text Box',
    value: 'ssTextBox',
  },
  {
    icon: <AlignLeft style={{ fontSize: 15 }} />,
    text: 'Text View',
    value: 'ssTextView',
  },
  {
    icon: <ArrowDown style={{ fontSize: 15 }} />,
    text: 'Drop Down',
    value: 'ssDropDown',
  },
  {
    icon: <CheckboxError style={{ fontSize: 15 }} />,
    text: 'Text Area',
    value: 'ssTextArea',
  },
  {
    icon: <RadioChecked style={{ fontSize: 15 }} />,
    text: 'Radio Button List',
    value: 'ssRadioButtonList',
  },
  { icon: <ClipboardPencil style={{ fontSize: 15 }} />, text: 'Summary', value: 'ssSummary' },
];

const OPTIONS_FOR_STRING_UPLOAD = [
  ...OPTIONS_FOR_STRING,
  {
    icon: <Upload style={{ fontSize: 15 }} />,
    text: 'FileInput',
    value: 'ssFileInput',
  },
];

const OPTIONS_FOR_BOOLEAN = [
  {
    icon: <CheckboxChecked style={{ fontSize: 15 }} />,
    text: 'Check Box',
    value: 'ssCheckBox',
  },
];

const OPTIONS_DATA_TYPE_CONTAINER = [
  {
    icon: <Copy style={{ fontSize: 15 }} />,
    text: 'Repeating Panel',
    value: 'ssRepeatingPanel',
  },
  {
    icon: <Table style={{ fontSize: 15 }} />,
    text: 'Grid',
    value: 'ssGrid',
  },
];

const OPTIONS_NON_BIND_CONTROLS = [
  {
    icon: <Link style={{ fontSize: 15 }} />,
    text: 'HyperLink',
    value: 'ssHyperLink',
  },
  {
    icon: <TextBold style={{ fontSize: 15 }} />,
    text: 'StaticText',
    value: 'ssStaticText',
  },
  {
    icon: <Cog style={{ fontSize: 15 }} />,
    text: 'Icon',
    value: 'ssIcon',
  },
  {
    icon: <OpenNew style={{ fontSize: 15 }} />,
    text: 'Modal',
    value: 'ssModal',
  },
  {
    icon: <Save style={{ fontSize: 15 }} />,
    text: 'Button',
    value: 'ssButton',
  },
  {
    icon: <Save style={{ fontSize: 15 }} />,
    text: 'SharePoint Button',
    value: 'ssButtonSharePoint',
  },
  {
    icon: <Save style={{ fontSize: 15 }} />,
    text: 'Button - Batch',
    value: 'ssButtonBatch',
  },
  {
    icon: <Save style={{ fontSize: 15 }} />,
    text: 'Button - Bulk Upload',
    value: 'ssButtonBulkUpload',
  },
  {
    icon: <Save style={{ fontSize: 15 }} />,
    text: 'Office Online Button',
    value: SS_CONTROL_TYPE.BUTTON_OFFICE_ONLINE,
  },
  {
    icon: <Save style={{ fontSize: 15 }} />,
    text: 'Request Print Button',
    value: SS_CONTROL_TYPE.BUTTON_CONTROL_PRINT,
  },
  {
    icon: <Save style={{ fontSize: 15 }} />,
    text: 'Inspection Measurement Data Button',
    value: 'ssInspectionMeasurementDataButton',
  },
  {
    icon: <Save style={{ fontSize: 15 }} />,
    text: 'Scorm Button',
    value: 'ssButtonScorm',
  },
  {
    icon: <Save style={{ fontSize: 15 }} />,
    text: 'Decision Tree Button',
    value: 'ssButtonDecisionTree',
  },
  {
    icon: <FileDocuments style={{ fontSize: 15 }} />,
    text: 'FileViewer',
    value: 'ssFileViewer',
  },

  {
    icon: <Search style={{ fontSize: 15 }} />,
    text: 'RepositoryZoom',
    value: 'ssRepositoryZoom',
  },

  {
    icon: <Upload style={{ fontSize: 15 }} />,
    text: 'Scorm File Input',
    value: 'ssScormFileInput',
  },
  {
    icon: <ClipboardSearch style={{ fontSize: 15 }} />,
    text: 'SavedSearch',
    value: 'ssSavedSearch',
  },
  {
    icon: <Search style={{ fontSize: 15 }} />,
    text: 'Regulatory Terms Zoom',
    value: 'ssRegulatoryTermsZoom',
  },
  {
    icon: <ChartBar style={{ fontSize: 15 }} />,
    text: 'Cluster Column Chart',
    value: 'ssClusterColumnChart',
  },
  {
    icon: <AiSparkles style={{ fontSize: 15 }} />,
    text: 'Similar Records',
    value: 'ssSimilarRecords',
  },
  {
    icon: <ClipboardPencil style={{ fontSize: 15 }} />,
    text: 'Role Actors Management',
    value: 'ssRoleActorsManagement',
  },
];

const useStyles = makeStyles({
  root: {
    '& div[class*="MuiTextField"]': {
      width: '379px',
      '@media (max-width: 1200px)': {
        width: 320,
      },
      '@media (max-width: 767px)': {
        width: '100%',
      },
    },
    padding: '30px',
  },
});

const dropDownBuilder = ({
  formEntityKey,
  isEntity,
  controlType,
  isNotBoundControl,
  isControlInContainer,
  canHaveTabSetInChildren,
}) => {
  if (!isNotBoundControl) {
    if (isEntity) {
      return OPTIONS_DATA_TYPE_CONTAINER;
    } else {
      switch (controlType) {
        case 'System.DateTime':
          return OPTIONS_FOR_DATE_TYPE;
        case 'System.Int32':
        case 'System.Decimal':
          return OPTIONS_FOR_NUMBERS;
        case 'System.String':
          return formEntityKey === 'SDC_DOCUMENT' ? OPTIONS_FOR_STRING_UPLOAD : OPTIONS_FOR_STRING;
        case 'System.Byte':
        case 'System.Boolean':
          return OPTIONS_FOR_BOOLEAN;
        default:
          return [];
      }
    }
  } else {
    const dropDownOptions = [...OPTIONS_NON_BIND_CONTROLS];
    if (!isControlInContainer) {
      dropDownOptions.push(
        {
          icon: <Card style={{ fontSize: 15 }} />,
          text: 'FieldGroup',
          value: 'ssFieldGroup',
        },
        {
          icon: <CheckboxError style={{ fontSize: 15 }} />,
          text: 'Panel',
          value: 'ssPanel',
        },
        {
          icon: <GantList style={{ fontSize: 15 }} />,
          text: 'SubForm',
          value: 'ssSubForm',
        }
      );
    }
    if (canHaveTabSetInChildren) {
      dropDownOptions.push({
        icon: <PresentationAudience style={{ fontSize: 15 }} />,
        text: 'TabSet',
        value: 'ssTabSet',
      });
    }

    return dropDownOptions.sort((a, b) =>
      a.text.localeCompare(b.text, undefined, { sensitivity: 'base' })
    );
  }
};

const DataTypePicker = ({
  controlParentId,
  dispatchStepChange,
  nodeProperties,
  isEntity,
  dataModel,
  previousControlId,
  selectPlaceholder,
  selectLabel,
  isNotBoundControl,
}) => {
  const classes = useStyles();
  const [selectedType, setSelectedType] = useState('');
  const [subFormNameList, setSubFormNameList] = useState([]);
  const [subFormName, setSubFormName] = useState('');
  const dispatch = useDispatch();
  const { formKey, formEntityKey } = useFormSelector(getFormInfo);
  const { controlType: parentControlType } = useFormSelector(getModelById, {
    id: controlParentId,
  });
  const subFormNamesArr = useFormSelector(getAllSubFormNames);
  const isControlInContainer = [
    SS_CONTROL_TYPE.GRID,
    SS_CONTROL_TYPE.GRID_COLUMN,
    SS_CONTROL_TYPE.SUB_GRID,
    SS_CONTROL_TYPE.FIELD_GROUP,
  ].includes(parentControlType);

  const canHaveTabSetInChildren = [SS_CONTROL_TYPE.FORM, SS_CONTROL_TYPE.SUB_FORM].includes(
    parentControlType
  );

  const optionsSelect = React.useMemo(
    () =>
      dropDownBuilder({
        formEntityKey,
        isEntity,
        controlType: nodeProperties?.DataType,
        isNotBoundControl,
        isControlInContainer,
        canHaveTabSetInChildren,
      }),
    /* eslint-disable react-hooks/exhaustive-deps */
    [isEntity, nodeProperties?.DataType]
  );

  const entityDefinition = useFormSelector(getEntityDefinition);

  const translations = useSelector(getTranslations);

  const defaultLabel = getPropTranslation(entityDefinition, translations, dataModel);

  const shouldDisplaySubFormDropdown = selectedType === SS_CONTROL_TYPE.SUB_FORM;

  React.useEffect(() => {
    if (!selectedType) {
      return;
    }
    if (selectedType !== SS_CONTROL_TYPE.SUB_FORM) {
      dispatch(
        addElementToFormModel({
          selectedType,
          controlParentId,
          dataModel,
          isEntity,
          defaultLabel,
          previousControlId,
          optionsSelect,
          nodeProperties,
          dispatchStepChange,
        })
      );
    } else {
      getSubFormNamesList(formEntityKey, formKey, subFormNamesArr).then((res) => {
        setSubFormNameList(res);
      });
    }
  }, [selectedType]);

  React.useEffect(() => {
    if (subFormName) {
      batch(() => {
        dispatch(setConfirmModalOpen(true));
        dispatch(
          addElementToFormModel({
            selectedType,
            controlParentId,
            dataModel,
            isEntity,
            defaultLabel,
            previousControlId,
            optionsSelect,
            nodeProperties,
            dispatchStepChange,
            formName: subFormName,
          })
        );
      });
    }
  }, [subFormName]);

  React.useEffect(() => {
    if (!isNotBoundControl) {
      if (!isEntity && ['System.DateTime'].includes(nodeProperties?.DataType)) {
        setSelectedType('ssDateBox');
      } else if (
        !isEntity &&
        ['System.Boolean', 'System.Byte'].includes(nodeProperties?.DataType)
      ) {
        setSelectedType('ssCheckBox');
      }
    }
  }, [isEntity, nodeProperties?.DataType, optionsSelect]);

  return (
    <div className={classes.root}>
      {!shouldDisplaySubFormDropdown ? (
        <Select
          size="small"
          fullWidth
          label={selectLabel}
          placeholder={selectPlaceholder}
          canDeselect={false}
          value={selectedType}
          onChange={(e) => {
            setSelectedType(e.target.value);
            e.stopPropagation();
          }}
          ui-ta={getUITA('DataTypePicker')}
        >
          {optionsSelect.map(({ icon, text, value }) => (
            <MenuItem key={value} value={value}>
              <MenuItemContentWithIcon label={text} icon={icon} />
            </MenuItem>
          ))}
        </Select>
      ) : (
        <Select
          size="small"
          fullWidth
          label="Select SubForm"
          placeholder="SubForm name"
          canDeselect={false}
          value={subFormName}
          onChange={(e) => {
            setSubFormName(e.target.value);
            e.stopPropagation();
          }}
          ui-ta={getUITA('SubFormPicker')}
        >
          {subFormNameList.map((value) => (
            <MenuItem key={value} value={value}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginLeft: 25 }}>{value}</div>
              </div>
            </MenuItem>
          ))}
        </Select>
      )}
    </div>
  );
};

export default DataTypePicker;
